import {ObjectId} from "../types";

export class TimeStamps {
  public _id?: ObjectId;
  public createdAt?: Date;
  public updatedAt?: Date;
}
